import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";


export const getUltimaLiquidacionContable = async () => { 
    const result = await PrivateInterceptor(`Suministros/Liquidaciones/ultimaLiquidacion`, 'GET');
    return result;
}

export const getLiquidacionIngreso = async (datos) => {
    const result = await PrivateInterceptor(`Suministros/Liquidaciones/liquidacionContableIngreso`, 'POST', {IdIngreso :datos.IdIngreso, IdLiquidacion: datos.IdLiquidacion} );
    return result;
}

export const getLiquidacionDetalle = async (IdIngreso) => {
    const result = await PrivateInterceptor(`Suministros/Liquidaciones/getLiquidacionDetalle`, 'POST', {IdIngreso} );
    return result;
}

export const GuardarLiquidacion = (Datos) => {
    const respuesta = PrivateInterceptor("Suministros/Liquidaciones/GuardarLiquidacion", "POST", {Datos});
    return respuesta;
};

export const EditarLiquidacion = (Datos) => {
    const respuesta = PrivateInterceptor("Suministros/Liquidaciones/EditarLiquidacion", "POST", {Datos});
    return respuesta;
};

export const getCategoriasLiquidaciones = async () => { 
    const result = await PrivateInterceptor(`Suministros/Liquidaciones/getCategoriasLiquidaciones`, 'GET');
    return result;
}

export const getBalanceIngresos = async(IdIngresoDetalle) =>{
    const result = await PrivateInterceptor(`Suministros/Liquidaciones/BalanceIngresos`, 'POST', {IdIngresoDetalle});
    return result;
}

export const postAplicarMontoDetalles = async(Detalles) =>{
    const result = await PrivateInterceptor(`Suministros/Liquidaciones/AplicarMontoDetalles`, 'POST', {Detalles});
    return result;
}

export const postLiquidacionesDetalles = async(Detalles) =>{
    const result = await PrivateInterceptor(`Suministros/Liquidaciones/GuardarLiquidacionDetalles`, 'POST',{Detalles});
    return result;
}


export const postEstadoLiquidacionesDetalles = async(Detalles) =>{
    const result = await PrivateInterceptor(`Suministros/Liquidaciones/EstadoLiquidacionDetalles`, 'POST',{Detalles});
    return result;
}

export const postActualizarMontoAplicadoDetalles= async(Detalles) =>{
    const result = await PrivateInterceptor(`Suministros/Liquidaciones/ActualizarMontoApliadoDetalles`, 'POST', {Detalles});
    return result;
}